export default [
  { value: 'EUR', displayName: 'Euro' },
  { value: 'USD', displayName: 'US Dollar' },
  { value: 'GBP', displayName: 'British Pound' },
  { value: 'DKK', displayName: 'Danish Krone' },
  { value: 'AUD', displayName: 'Australian Dollar' },
  { value: 'PLN', displayName: 'Polish Zloty' },
  { value: 'SEK', displayName: 'Swedish Krona' },
  { value: 'TRY', displayName: 'Turkish Lira' },
  { value: 'JPY', displayName: 'Japanese Yen' },
  { value: 'MXN', displayName: 'Mexican Peso' },
  { value: 'CAD', displayName: 'Canadian Dollar' },
  { value: 'CHF', displayName: 'Swiss Franc' },
  { value: 'INR', displayName: 'Indian Rupee' },
  { value: 'RUB', displayName: 'Russian Rubles' },
  { value: 'BGN', displayName: 'Bulgarian Lev' },
  { value: 'BRL', displayName: 'Brazilian Real' },
  { value: 'NOK', displayName: 'Norwegian Krone' },
  { value: 'NZD', displayName: 'New Zealand Dollar' },
  { value: 'ZAR', displayName: 'South African Rand' },
  { value: 'THB', displayName: 'Thai Baht' },
  { value: 'CNY', displayName: 'Chinese Yuan' },
  { value: 'TWD', displayName: 'New Taiwan Dollar' },
  { value: 'CZK', displayName: 'Czech Koruna' },
  { value: 'HUF', displayName: 'Hungarian Forint' },
  { value: 'ARS', displayName: 'Argentine Peso' },
  { value: 'PHP', displayName: 'Philippine Peso' },
  { value: 'COP', displayName: 'Colombian Peso' },
  { value: 'RON', displayName: 'Romanian Leu' },
  { value: 'PKR', displayName: 'Pakistani Rupee' },
  { value: 'GTQ', displayName: 'Guatemalan Quetzal' },
  { value: 'HNL', displayName: 'Honduran Lempira' },
  { value: 'PAB', displayName: 'Panamanian Balboa' },
  { value: 'CLP', displayName: 'Chilean Peso' },
  { value: 'BOB', displayName: 'Bolivian Boliviano' },
  { value: 'CRC', displayName: 'Costa Rican Colon' },
  { value: 'NIO', displayName: 'Nicaraguan Cordoba' },
  { value: 'PEN', displayName: 'Peruvian Sol' },
  { value: 'ISK', displayName: 'Icelandic Krona' },
  { value: 'JMD', displayName: 'Jamaican Dollar' },
  { value: 'AOA', displayName: 'Angolan Kwanza' },
  { value: 'MYR', displayName: 'Malaysian Ringgit' },
  { value: 'NGN', displayName: 'Nigeria Naira' },
  { value: 'KES', displayName: 'Kenyan Shilling' },
  { value: 'SGD', displayName: 'Singapore dollar' },
  { value: 'HKD', displayName: 'Hong Kong dollar' },
  { value: 'AZN', displayName: 'Azerbaijanian Manat' },
  { value: 'AMD', displayName: 'Armenian Dram' },
  { value: 'BDT', displayName: 'Bangladeshi taka' },
  { value: 'LKR', displayName: 'Sri Lankan rupee' },
  { value: 'BWP', displayName: 'Botswana Pula' },
  { value: 'RWF', displayName: 'Rwandan Francs' },
  { value: 'XAF', displayName: 'Cameroon Francs' },
  { value: 'MKD', displayName: 'Macedonian Denar' },
  { value: 'KRW', displayName: 'Korean Wong' },
  { value: 'VND', displayName: 'Vietnamese Dong' },
];
